import axios from 'axios'
// import router from '../routerManuaConfig'
import router from '../router/index'
import store from '../store'
import Vue from 'vue'

import applicationUserManager from '../Auth/applicationusermanager'

let base = ''
// 如果是IIS部署，用这个，因为 IIS 只能是 CORS 跨域，不能代理
// let base = process.env.NODE_ENV=="production"? 'http://localhost:8081':'';

// 请求延时
axios.defaults.timeout = 300000

var storeTemp = store
axios.interceptors.request.use(
  (config) => {
    var curTime = new Date()
    var expiretime = new Date(Date.parse(storeTemp.state.tokenExpire))
    config.headers['Cache-Control'] = 'no-cache, no-store'

    config.headers['Pragma'] = 'no-cache'
    if (storeTemp.state.token && curTime < expiretime && storeTemp.state.tokenExpire) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = 'Bearer ' + storeTemp.state.token
    }

    saveRefreshtime()

    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // 超时请求处理
    var originalRequest = error.config
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1 && !originalRequest._retry) {
      Vue.prototype.$message({
        message: '请求超时！',
        type: 'error',
      })

      originalRequest._retry = true
      return null
    }

    if (error.response) {
      if (error.response.status == 401) {
        var curTime = new Date()
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime))
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({ token: window.localStorage.Token }).then((res) => {
            if (res.success) {
              Vue.prototype.$message({
                message: 'refreshToken success! loading data...',
                type: 'success',
              })

              store.commit('saveToken', res.response.token)

              var curTime = new Date()
              var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + res.response.expires_in))
              store.commit('saveTokenExpire', expiredate)

              error.config.__isRetryRequest = true
              error.config.headers.Authorization = 'Bearer ' + res.response.token
              return axios(error.config)
            } else {
              // 刷新token失败 清除token信息并跳转到登录页面
              ToLogin()
            }
          })
        } else {
          // 返回 401，并且不知用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin()
        }
      }
      // 403 无权限
      if (error.response.status == 403) {
        Vue.prototype.$message({
          message: '失败！该操作无权限',
          type: 'error',
        })
        return null
      }
      // 429 ip限流
      if (error.response.status == 429) {
        Vue.prototype.$message({
          message: '刷新次数过多，请稍事休息重试！',
          type: 'error',
        })
        return null
      }
    }
    return '' // 返回接口返回的错误信息
  }
)

export const BaseApiUrl = base

// 登录
export const requestLogin = (params) => {
  return axios.get(`${base}/api/login/jwttoken3.0`, { params: params }).then((res) => res.data)
}
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data)
}

export const refreshToken = (params) => {
  return axios.get(`${base}/api/login/RefreshToken`, { params: params }).then((res) => res.data)
}

export const saveRefreshtime = (params) => {
  let nowtime = new Date()
  let lastRefreshtime = window.localStorage.refreshtime ? new Date(window.localStorage.refreshtime) : new Date(-1)
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire))

  let refreshCount = 1 //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount)
    window.localStorage.refreshtime = lastRefreshtime
  } else {
    window.localStorage.refreshtime = new Date(-1)
  }
}
const ToLogin = (params) => {
  store.commit('saveToken', '')
  store.commit('saveTokenExpire', '')
  store.commit('saveTagsData', '')
  window.localStorage.removeItem('user')
  window.localStorage.removeItem('NavigationBar')

  if (global.IS_IDS4) {
    applicationUserManager.login()
  } else {
    // router.replace({
    //     path: "/login",
    //     query: {redirect: router.currentRoute.fullPath}
    // });

    // window.location.reload()
    console.log('tologin---刷新token失败')
    window.location.href = '/user-login'
  }
}

export const getUserByToken = (params) => {
  return axios.get(`${base}/api/user/getInfoByToken`, { params: params }).then((res) => res.data)
}

export function testapi2() {
  console.log('api is ok.')
}

export const testapi = (pa) => {
  console.log('api is ok.')
}

// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, { params: params })
}
export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, { params: params })
}
export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params)
}
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params)
}
export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, { params: params }) //没做
}

// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, { params: params })
}
export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, { params: params })
}
export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params)
}
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params)
}

// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, { params: params })
}
export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, { params: params })
}
export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params)
}
export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params)
}

// 菜单模块管理
export const getPermissionListPage = (params) => {
  return axios.get(`${base}/api/permission/get`, { params: params })
}
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, { params: params })
}
export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, { params: params })
}
export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params)
}
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params)
}
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  })
}
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  })
}

export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params)
}
export const getNavigationBar = (params) => {
  return axios.get(`${base}/api/permission/GetNavigationBar`, { params: params }).then((res) => res.data)
}

// Bug模块管理
export const getBugListPage = (params) => {
  return axios.get(`${base}/api/TopicDetail/get`, { params: params })
}
export const removeBug = (params) => {
  return axios.delete(`${base}/api/TopicDetail/delete`, { params: params })
}
export const editBug = (params) => {
  return axios.put(`${base}/api/TopicDetail/update`, params)
}
export const addBug = (params) => {
  return axios.post(`${base}/api/TopicDetail/post`, params)
}

// 博客模块管理
export const getBlogListPage = (params) => {
  return axios.get(`${base}/api/Blog`, { params: params })
}
export const getBlogDeatil = (params) => {
  return axios.get(`${base}/api/Blog/DetailNuxtNoPer`, { params: params })
}
export const editBlog = (params) => {
  return axios.put(`${base}/api/Blog/update`, params)
}
export const removeBlog = (params) => {
  return axios.delete(`${base}/api/Blog/delete`, { params: params })
}

// 日志
export const getLogs = (params) => {
  return axios.get(`${base}/api/Monitor/get`, { params: params })
}
export const getRequestApiinfoByWeek = (params) => {
  return axios.get(`${base}/api/Monitor/GetRequestApiinfoByWeek`, {
    params: params,
  })
}
export const getAccessApiByDate = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByDate`, {
    params: params,
  })
}
export const getAccessApiByHour = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessApiByHour`, {
    params: params,
  })
}
export const getServerInfo = (params) => {
  return axios.get(`${base}/api/Monitor/Server`, { params: params })
}
export const getAccessLogs = (params) => {
  return axios.get(`${base}/api/Monitor/GetAccessLogs`, { params: params })
}
export const getIds4UsersGrow = (params) => {
  return axios.get(`${base}/api/Monitor/GetIds4Users`, { params: params })
}

// Task管理
export const getTaskListPage = (params) => {
  return axios.get(`${base}/api/TasksQz/get`, { params: params })
}
export const removeTask = (params) => {
  return axios.delete(`${base}/api/TasksQz/delete`, { params: params })
}
export const editTask = (params) => {
  return axios.put(`${base}/api/TasksQz/put`, params)
}
export const addTask = (params) => {
  return axios.post(`${base}/api/TasksQz/post`, params)
}

export const startJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StartJob`, { params: params })
}
export const stopJob = (params) => {
  return axios.get(`${base}/api/TasksQz/StopJob`, { params: params })
}
export const reCovery = (params) => {
  return axios.get(`${base}/api/TasksQz/ReCovery`, { params: params })
}

// 事业部管理
export const department_get = (params) => {
  return axios.get(`${base}/api/department/Get`, { params: params })
}
export const department_get2 = (params) => {
  return axios.get(`${base}/api/department/Get/${params}`)
}
export const department_delete = (params) => {
  return axios.delete(`${base}/api/department/Delete`, { params: params })
}
export const department_post = (params) => {
  return axios.post(`${base}/api/department/Post`, params)
}
export const department_put = (params) => {
  return axios.put(`${base}/api/department/Put`, params)
}

// Layer1列表
export const account_info_get = (params) => {
  return axios.get(`${base}/api/account_info/Get`, { params: params })
}
export const account_info_get2 = (params) => {
  return axios.get(`${base}/api/account_info/Get/${params}`)
}
export const account_info_put = (params) => {
  return axios.put(`${base}/api/account_info/Put`, params)
}

// 非Layer1列表
export const account_info_GetNoLayerList = (params) => {
  return axios.get(`${base}/api/account_info/GetNoLayerList`, {
    params: params,
  })
}
export const account_info_Post = (params) => {
  return axios.post(`${base}/api/account_info/Post`, params)
}
export const account_info_GetUpLevel = (params) => {
  return axios.get(`${base}/api/account_info/GetUpLevel`, { params: params })
}

export const account_info_GetUpLevel2 = (params) => {
  return axios.get(`${base}/api/account_info/GetUpLevel2`, { params: params })
}

// 渠道管理
export const channel_Get = (params) => {
  return axios.get(`${base}/api/channel/Get`, { params: params })
}
export const channel_GetChannel = (params) => {
  return axios.get(`${base}/api/channel/GetChannel`, { params: params })
}
export const channel_Get2 = (params) => {
  return axios.get(`${base}/api/channel/Get/${params}`)
}
export const channel_Delete = (params) => {
  return axios.delete(`${base}/api/channel/Delete`, { params: params })
}
export const channel_Post = (params) => {
  return axios.post(`${base}/api/channel/Post`, params)
}
export const channel_Put = (params) => {
  return axios.put(`${base}/api/channel/Put`, params)
}

// 客户审批列表
export const account_info_GetProcessReview = (params) => {
  return axios.get(`${base}/api/account_info/GetProcessReview`, {
    params: params,
  })
}

export const organization_get_user_under_role = (params) => {
  return axios.post(`${base}/api/organization/get_user_under_role`, params)
}

export const approval_request_Get = (params) => {
  return axios.get(`${base}/api/approval_request/Get`, { params: params })
}

export const approval_request_Put = (params) => {
  return axios.put(`${base}/api/approval_request/Put`, params)
}

export const approval_request_GetApprovalList = (params) => {
  // return axios.get(`${base}/api​/approval_request​/GetApprovalList`, {params: params});
  return axios.get(`${base}/api/approval_request/GetApprovalList`, {
    params: params,
  })
}

export const approval_request_GetReason = (params) => {
  return axios.get(`${base}/api/approval_request/GetReason`, {
    params: params,
  })
}

// 汇报关系
export const User_Get_report = (params) => {
  return axios.get(`${base}/api/User/Get_report`, params)
}
export const organization_Get2 = (params) => {
  return axios.get(`${base}/api/organization/Get/${params}`)
}

// 省市区三级联动
export const region_Get = (params) => {
  return axios.get(`${base}/api/region/Get`, params)
}
export const region_Get_city = (params) => {
  return axios.get(`${base}/api/region/Get_city`, params)
}

// 归属大区
export const sales_region_Get = (params) => {
  return axios.get(`${base}/api/sales_region/Get`, params)
}

export const sales_region_Post = (params) => {
  return axios.post(`${base}/api/sales_region/Post`, params)
}

export const sales_region_Put = (params) => {
  return axios.put(`${base}/api/sales_region/Put`, params)
}

export const sales_region_Delete = (params) => {
  return axios.delete(`${base}/api/sales_region/Delete`, { params: params })
}

// 大区城市管理

export const sales_region_map_Get = (params) => {
  return axios.get(`${base}/api/sales_region_map/Get/${params}`)
}

export const sales_region_map_Put = (params) => {
  return axios.put(`${base}/api/sales_region_map/Put`, params)
}

// 门店列表
export const store_data_Get = (params) => {
  return axios.post(`${base}/api/store_data/Get`, params)
}

export const store_data_Get2 = (params) => {
  return axios.get(`${base}/api/store_data/Get/${params}`)
}

// 门店审批补充接口

export const store_data_UpdateStoreEnd = (params) => {
  return axios.put(`${base}/api/store_data/UpdateStoreEnd`, params)
}

// 客户审批补充接口

export const account_info_UpdateStoreEnd = (params) => {
  return axios.put(`${base}/api/account_info/UpdateAccountEnd`, params)
}
// 门店新增

export const store_data_Post = (params) => {
  return axios.post(`${base}/api/store_data/Post`, params)
}

// 修改门店

export const store_data_Put = (params) => {
  return axios.put(`${base}/api/store_data/Put`, params)
}

// 门店审核

export const store_data_GetProcessReview = (params) => {
  return axios.post(`${base}/api/store_data/GetProcessReview`, params)
}

// 门店认领列表

export const store_data_Store_claim = (params) => {
  return axios.post(`${base}/api/store_data/Store_claim`, params)
}

// 门店认领

export const store_data_PostClaim = (params) => {
  return axios.post(`${base}/api/store_data/PostClaim`, params)
}

// 门店产品列表

export const product_GetSelectList = (params) => {
  return axios.get(`${base}/api/product/GetSelectList`, params)
}

// 组织架构
export const workday_map = (params) => {
  return axios.get(`${base}/api/workday/GetTree`, params)
}

// 图片管理

// 白名单管理
export const white_list_Get = (params) => {
  return axios.get(`${base}/api/white_list/Get`, { params: params })
}
// export const getUserListPage = params => {
//     return axios.get(`${base}/api/user/get`, );
// };
export const white_list_Get2 = (params) => {
  return axios.get(`${base}/api/white_list/Get/${params}`)
}
export const white_list_Delete = (params) => {
  return axios.delete(`${base}/api/white_list/Delete`, { params: params })
}
export const white_list_Post = (params) => {
  return axios.post(`${base}/api/white_list/Post`, params)
}
export const white_list_Put = (params) => {
  return axios.put(`${base}/api/white_list/Put`, params)
}

// 黑名单管理

export const black_list_Get = (params) => {
  return axios.get(`${base}/api/black_list/Get`, { params: params })
}
export const black_list_Get2 = (params) => {
  return axios.get(`${base}/api/black_list/Get/${params}`)
}
export const black_list_Delete = (params) => {
  return axios.delete(`${base}/api/black_list/Delete`, { params: params })
}
export const black_list_Post = (params) => {
  return axios.post(`${base}/api/black_list/Post`, params)
}
export const black_list_Put = (params) => {
  return axios.put(`${base}/api/black_list/Put`, params)
}

// 短信模板管理
export const sms_template_Get = (params) => {
  return axios.get(`${base}/api/sms_template/Get`, { params: params })
}
export const sms_template_Get2 = (params) => {
  return axios.get(`${base}/api/sms_template/Get/${params}`)
}
export const sms_template_Delete = (params) => {
  return axios.delete(`${base}/api/sms_template/Delete`, { params: params })
}
export const sms_template_Post = (params) => {
  return axios.post(`${base}/api/sms_template/Post`, params)
}
export const sms_template_Put = (params) => {
  return axios.put(`${base}/api/sms_template/Put`, params)
}

// 邮件模板管理
export const mail_template_Get = (params) => {
  return axios.get(`${base}/api/mail_template/Get`, { params: params })
}
export const mail_template_Get2 = (params) => {
  return axios.get(`${base}/api/mail_template/Get/${params}`)
}
export const mail_template_Delete = (params) => {
  return axios.delete(`${base}/api/mail_template/Delete`, { params: params })
}
export const mail_template_Post = (params) => {
  return axios.post(`${base}/api/mail_template/Post`, params)
}
export const mail_template_Put = (params) => {
  return axios.put(`${base}/api/mail_template/Put`, params)
}

// 系统代码管理
export const system_code_Get = (params) => {
  return axios.get(`${base}/api/system_code/Get`, { params: params })
}

export const system_code_Get2 = (params) => {
  return axios.get(`${base}/api/system_code/Get/${params}`)
}
export const system_code_Delete = (params) => {
  return axios.delete(`${base}/api/system_code/Delete`, { params: params })
}
export const system_code_Post = (params) => {
  return axios.post(`${base}/api/system_code/Post`, params)
}
export const system_code_Put = (params) => {
  return axios.put(`${base}/api/system_code/Put`, params)
}

// 验证码查询

export const sms_log_Get = (params) => {
  return axios.get(`${base}/api/sms_log/Get`, { params: params })
}

// ECP列表

export const ecp_Get = (params) => {
  return axios.post(`${base}/api/ecp/Get`, params)
}
export const ecpGet2 = (params) => {
  return axios.get(`${base}/api/ecp/Get/${params}`)
}
export const ecp_Put = (params) => {
  return axios.put(`${base}/api/ecp/Put`, params)
}
export const ecp_Put_claim = (params) => {
  return axios.put(`${base}/api/ecp/Put_claim`, params)
}
export const ecp_Put_claim1 = (params) => {
  return axios.put(`${base}/api/ecp/Put_claim1`, params)
}

// ECP确认列表

// export const ecp_claim_store_Get = params => {
//     return axios.get(`${base}/api/ecp_claim_store/Get`, params);
// };
// export const ecp_claim_store_Get2 = params => {
//     return axios.get(`${base}/api/ecp_claim_store/Get/${params}`)
// };
// export const ecp_claim_store_Delete = params => {
//     return axios.delete(`${base}/api/ecp_claim_store/Delete`, {params: params});
// };
// export const ecp_claim_store_Post = params => {
//     return axios.post(`${base}/api/ecp_claim_store/Post`, params);
// };
// export const ecp_claim_store_Put = params => {
//     return axios.put(`${base}/api/ecp_claim_store/Put`, params);
// };

// 活动列表
export const promotion_Get = (params) => {
  return axios.get(`${base}/api/promotion/GetSelectList`, params)
}

// 证件管理
export const licence_Get2 = (params) => {
  return axios.get(`${base}/api/licence/Get/${params}`)
}

// 添加证件管理
export const licence_Post = (params) => {
  return axios.post(`${base}/api/licence/Post`, params)
}

// SOI报表管理

// 下载
export const report_template_SOIDownloadTemplates = (params) => {
  return axios.get(`${base}/api/report_template/SOIDownloadTemplates?${params}` + '&n=' + encodeURIComponent(Math.random()))
}

// 预览
export const report_template_SOIOnlinePreview = (params) => {
  return axios.get(`${base}/api/report_template/SOIOnlinePreview`, params)
}

// 客户导出

export const account_info_ExportAccount = (params) => {
  return axios.get(`${base}/api/account_info/ExportAccount`, params)
}

// 获取组织架构信息RSM/ASM/NKAM
export const store_data_GetOrganizationInfo = (params) => {
  return axios.post(`${base}/api/store_data/GetOrganizationInfo`, params)
}

// 门店列表导出

export const store_data_ExportStore = (params) => {
  return axios.get(`${base}/api/store_data/ExportStore`, params)
}
// export const store_data_ExportStore = params => {
//     // return axios.get(`${base}​/api/store_data/ExportStore`, params);
//     return axios.get(`${base}​/api/store_data/ExportStore`,params)
// };

// 下载月报

export const report_template_data_SOIMonthlyReport = (params) => {
  return axios.get(`${base}/api/report_template_data/SOIMonthlyReport?${params}` + '&n=' + encodeURIComponent(Math.random()))
}

export const report_template_data_GetMonthlyReportNotFiled = (params) => {
  return axios.get(`${base}/api/report_template_data/GetMonthlyReportNotFiled?${params}` + '&n=' + encodeURIComponent(Math.random()))
}

// export const report_template_data_SOIMonthlyReport = params => {
//     return axios.get(`${base}/api/report_template_data/DownloadCustomerBusinessTypeImportData?${params}`+ "&n="+encodeURIComponent(Math.random()));
// };
export const report_template_DownloadCustomerBusinessTypeImportData = (params) => {
  return axios.get(`${base}/api/report_template/DownloadCustomerBusinessTypeImportData?${params}` + '&n=' + encodeURIComponent(Math.random()))
}

// ECP导出
export const ecp_ExportECP = (params) => {
  return axios.get(`${base}/api/ecp/ExportECP`, params)
}

// 当前用户是否为客户负责人
export const account_info_IsAccountManage = (params) => {
  return axios.get(`${base}/api/account_info/IsAccountManage`, params)
}

// 当前用户是否为客户负责人
export const region_GetCityType = (params) => {
  return axios.post(`${base}/api/region/GetCityType`, params)
}

export const account_info_GetClaimList = (params) => {
  return axios.post(`${base}/api/account_info/GetClaimList`, params)
}

export const account_info_PostClaim = (params) => {
  return axios.post(`${base}/api/account_info/PostClaim`, params)
}

export const report_template_data_SOIImportData = (params) => {
  return axios.post(`${base}/api/report_template_data/SOIImportData?${params}`)
}

export const report_template_data_SOIImportData2 = (params) => {
  return axios.post(`${base}/api/report_template_data/SOIImportData2`, params)
}

// 查询下属
export const organization_Find_subordinates = (params) => {
  return axios.get(`${base}/api/organization/Find_subordinates?${params}`)
}

export const organization_Get_role_subordinate = (params) => {
  return axios.post(`${base}/api/organization/Get_role_subordinate`, params)
}

export const account_info_Get_region = (params) => {
  return axios.get(`${base}/api/account_info/Get_region?${params}`)
}

// sso登录
export const ssorequestLogin = (params) => {
  return axios.get(`${base}/api/login/GetJwtTokensso`, { params: params }).then((res) => res.data)
}

// 首页
export const account_info_GetIndex = (params) => {
  return axios.get(`${base}/api/account_info/GetIndex`, params)
}

// 产品列表
export const product_Get = (params) => {
  return axios.post(`${base}/api/product/Get`, params)
}

// 产品下拉列表
export const product_GetSelect = (params) => {
  return axios.get(`${base}/api/product/GetSelect`, params)
}

// 产品下拉列表2
export const product_GetSelectList2 = (params) => {
  return axios.get(`${base}/api/product/GetSelectList`, params)
}

// 添加产品
export const product_Post = (params) => {
  return axios.post(`${base}/api/product/Post`, params)
}

// 更新产品
export const product_Put = (params) => {
  return axios.put(`${base}/api/product/Put`, params)
}

// 查询产品详情
export const product_upccode_Get_pid = (params) => {
  return axios.get(`${base}/api/product_upccode/Get_pid?${params}`)
}

// 产品模板下载

export const product_DownloadUpcData = (params) => {
  return axios.get(`${base}/api/product/DownloadUpcData`, params)
}

// 产品列表导出

export const product_DownloadProduct_info = (params) => {
  return axios.get(`${base}/api/product/DownloadProduct_info?${params}`)
}

export const product_DownloadProduct_info_new = (params) => {
  return axios.get(`${base}/api/product/DownloadProduct_info_new?${params}`)
}

export const Account_info_CheckGroupID = (params) => {
  return axios.post(`${base}/api/Account_info/CheckGroupID`, params)
}

export const Account_info_CheckGroupID2 = (params) => {
  return axios.post(`${base}/api/Account_info/CheckGroupID2`, params)
}

export const Account_info_GetDISList = (params) => {
  return axios.get(`${base}/api/Account_info/GetDISList`, { params: params })
}

// export const report_template_DownloadDIS = (params) => {
//   return axios.get(`${base}/api/report_template/DownloadDIS?${params}` + '&n=' + encodeURIComponent(Math.random()))
// }

export const report_template_DownloadDIS = (params) => {
  return axios.get(`${base}/api/report_template/DownloadDIS`, { params: params })
}

export const Account_info_DISPut = (params) => {
  return axios.put(`${base}/api/Account_info/DISPut`, params)
}

export const report_template_data_DISImportData2 = (params) => {
  return axios.post(`${base}/api/report_template_data/DISImportData2`, params)
}

export const Account_info_IsDIS = (params) => {
  return axios.get(`${base}/api/Account_info/IsDIS`, params)
}

// 物料
export const trial_info_Get_material = (params) => {
  return axios.get(`${base}/api/trial_info/Get_material`, { params: params })
}

export const trial_info_Get_material_byid = (params) => {
  return axios.get(`${base}/api/trial_info/Get_material_byid`, {
    params: params,
  })
}

export const trial_info_Post_material = (params) => {
  return axios.post(`${base}/api/trial_info/Post_material`, params)
}

export const trial_info_Put_material = (params) => {
  return axios.put(`${base}/api/trial_info/Put_material`, params)
}

// 试戴片
export const trial_info_Get_Get_Trial = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Trial`, { params: params })
}

export const trial_info_require_product_byid = (params) => {
  return axios.get(`${base}/api/trial_info/require_product_byid`, {
    params: params,
  })
}

export const trial_info_Get_Trial_Require = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Trial_Require`, {
    params: params,
  })
}

export const trial_info_budget_info = (params) => {
  return axios.get(`${base}/api/trial_info/budget_info`, { params: params })
}

export const trial_info_Put_budget_info = (params) => {
  return axios.put(`${base}/api/trial_info/Put_budget_info`, params)
}

export const trial_info_Put_Material_Order = (params) => {
  return axios.put(`${base}/api/trial_info/Put_Material_Order`, params)
}

export const trial_info_Put_Trial_product_info = (params) => {
  return axios.put(`${base}/api/trial_info/Put_Trial_product_info`, params)
}

export const trial_info_Put_Trial = (params) => {
  return axios.put(`${base}/api/trial_info/Put_Trial`, params)
}

export const trial_info_trial_product_upc_byid = (params) => {
  return axios.get(`${base}/api/trial_info/trial_product_upc_byid`, {
    params: params,
  })
}

export const trial_info_require_product_upc_byid = (params) => {
  return axios.get(`${base}/api/trial_info/require_product_upc_byid`, {
    params: params,
  })
}
;``
export const trial_info_Post_Trial_product_info = (params) => {
  return axios.post(`${base}/api/trial_info/Post_Trial_product_info`, params)
}

export const trial_info_Post_Trial = (params) => {
  return axios.post(`${base}/api/trial_info/Post_Trial`, params)
}

export const trial_info_Post_Material_Order = (params) => {
  return axios.post(`${base}/api/trial_info/Post_Material_Order`, params)
}

export const trial_info_Get_Trial_Store = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Trial_Store`, {
    params: params,
  })
}

export const trial_info_Get_Trial_Store_id = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Trial_Store_id`, {
    params: params,
  })
}

// 启用试戴
export const trial_info_Post_Product_UpdateTrail = (params) => {
  return axios.put(`${base}/api/trial_info/Post_Product_UpdateTrail`, params)
}

// 物料申请列表
export const trial_info_Get_Material_Require = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Material_Require`, {
    params: params,
  })
}

export const trial_info_Put_Trail_file = (params) => {
  return axios.put(`${base}/api/trial_info/Put_Trail_file`, params)
}

export const trial_info_Require_Material_ById = (params) => {
  return axios.get(`${base}/api/trial_info/Require_Material_ById`, {
    params: params,
  })
}

export const approval_request_Get_Material = (params) => {
  return axios.get(`${base}/api/approval_request/Get_Material`, {
    params: params,
  })
}

export const approval_request_Put_Material = (params) => {
  return axios.put(`${base}/api/approval_request/Put_Material`, params)
}

export const trial_info_Put_Material_Require_Price = (params) => {
  return axios.put(`${base}/api/trial_info/Put_Material_Require_Price`, params)
}

export const trial_info_Put_return = (params) => {
  return axios.put(`${base}/api/trial_info/Put_return`, params)
}

export const trial_info_Get_Material_Require_approval = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Material_Require_approval`, {
    params: params,
  })
}

export const trial_info_Get_Trial_Require_Approval = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Trial_Require_Approval`, {
    params: params,
  })
}

export const trial_info_Delete_material = (params) => {
  return axios.put(`${base}/api/trial_info/Delete_material`, params)
}

export const trial_info_Overdue = (params) => {
  return axios.get(`${base}/api/trial_info/Overdue`, { params: params })
}

export const store_data_Reback_Store = (params) => {
  return axios.post(`${base}/api/store_data/Reback_Store?${params}`)
}

export const Account_info_Reback_account = (params) => {
  return axios.post(`${base}/api/Account_info/Reback_account?${params}`)
}

// 产品管理new
export const product_GetProduct_List = (params) => {
  return axios.post(`${base}/api/product/GetProduct_List`, params)
}

export const MessageInfo_Get = (params) => {
  return axios.get(`${base}/api/MessageInfo/Get`, { params: params })
}

export const report_template_Download_Hybrid_KA = (params) => {
  return axios.get(`${base}/api/report_template/Download_Hybrid_KA`, {
    params: params,
  })
}

export const product_GetSelect_upc = (params) => {
  return axios.get(`${base}/api/product/GetSelect_upc`, { params: params })
}

export const product_DownloadUpcData_new = (params) => {
  return axios.get(`${base}/api/product/DownloadUpcData_new`, {
    params: params,
  })
}

export const product_Put_new = (params) => {
  return axios.put(`${base}/api/product/Put_new`, params)
}

export const product_DownloadProduct_Effective_Time = (params) => {
  return axios.get(`${base}/api/product/DownloadProduct_Effective_Time`, {
    params: params,
  })
}

export const trial_info_DownloadTrial_info = (params) => {
  return axios.get(`${base}/api/trial_info/DownloadTrial_info`, {
    params: params,
  })
}

export const trial_info_DownloadMaterial_info = (params) => {
  return axios.get(`${base}/api/trial_info/DownloadMaterial_info`, {})
}

export const report_template_Download_Organization_role = (params) => {
  return axios.get(`${base}/api/report_template/Download_Organization_role`, {
    params: params,
  })
}

// 门店配额列表
export const store_quota_GetQuotaPages = (params) => {
  return axios.get(`${base}/api/store_quota/GetQuotaPages`, {
    params: params,
  })
}

// 门店配额待审批
export const store_quota_GetNotApprove = (params) => {
  return axios.get(`${base}/api/store_quota/GetNotApprove`, {
    params: params,
  })
}

// 门店配额审批
export const store_quota_GetApprove = (params) => {
  return axios.get(`${base}/api/store_quota/GetApprove`, {
    params: params,
  })
}

// 门店配额详情
export const store_quota_GetQuotaInfo = (params) => {
  return axios.get(`${base}/api/store_quota/GetQuotaInfo`, {
    params: params,
  })
}

// 门店配额审批接口
export const store_quota_Post = (params) => {
  return axios.post(`${base}/api/store_quota/Post`, params)
}

// 门店配额申请
export const store_quota_AdjustQuota = (params) => {
  return axios.post(`${base}/api/store_quota/AdjustQuota`, params)
}

// 门店促销配额归零
export const store_quota_ResetQuota = (params) => {
  return axios.get(`${base}/api/store_quota/ResetQuota`, {
    params: params,
  })
}

export const store_quota_GetStoreQoutaInfo = (params) => {
  return axios.get(`${base}/api/store_quota/GetStoreQoutaInfo`, {
    params: params,
  })
}

// 会员超限管理

export const member_overrun_ExportExcel = (params) => {
  return axios.get(`${base}/api/member_overrun/ExportExcel`, {
    params: params,
  })
}

export const member_overrun_GetApprove = (params) => {
  return axios.get(`${base}/api/member_overrun/GetApprove`, {
    params: params,
  })
}

export const member_overrun_GetCustomerLimit = (params) => {
  return axios.get(`${base}/api/member_overrun/GetCustomerLimit`, {
    params: params,
  })
}

export const member_overrun_GetNotApprove = (params) => {
  return axios.get(`${base}/api/member_overrun/GetNotApprove`, {
    params: params,
  })
}

export const member_overrun_GetOverrunPages = (params) => {
  return axios.get(`${base}/api/member_overrun/GetOverrunPages`, {
    params: params,
  })
}

export const ws_highrisk_ExportData = (params) => {
  return axios.get(`${base}/api/ws_highrisk/ExportData`, {
    params: params,
  })
}

export const ws_highrisk_GetImportTemplate = (params) => {
  return axios.get(`${base}/api/ws_highrisk/GetImportTemplate`, {
    params: params,
  })
}

export const member_overrun_GetOverrunInfo = (params) => {
  return axios.get(`${base}/api/member_overrun/GetOverrunInfo`, {
    params: params,
  })
}

export const member_overrun_OrdinaryOverlimit = (params) => {
  return axios.post(`${base}/api/member_overrun/OrdinaryOverlimit`, params)
}

export const member_overrun_PostApproval = (params) => {
  return axios.post(`${base}/api/member_overrun/PostApproval`, params)
}

export const member_overrun_SpecialOverlimit = (params) => {
  return axios.post(`${base}/api/member_overrun/SpecialOverlimit`, params)
}

// export const Limit_store_data_GetStoreData = (params) => {
//   return axios.post(`${base}/api/store_data/Get`, {
//     params: params,
//   });
// };

export const Limit_store_data_GetStoreData = (params) => {
  return axios.post(`${base}/api/store_data/Get`, params)
}

export const Limit_GetStoreData = (params) => {
  return axios.get(`${base}/api/Limit/GetStoreData`, {
    params: params,
  })
}

export const store_quota_GetQoutasListExcel = (params) => {
  return axios.get(`${base}/api/store_quota/GetQoutasListExcel`, {
    params: params,
  })
}

export const store_quota_ExportQuotaExcel = (params) => {
  return axios.get(`${base}/api/store_quota/ExportQuotaExcel`, {
    params: params,
  })
}

export const member_overrun_ExportECPInfoExcel = (params) => {
  return axios.get(`${base}/api/member_overrun/ExportECPInfoExcel`, {
    params: params,
  })
}

export const member_overrun_VerifyOverlimit = (params) => {
  return axios.post(`${base}/api/member_overrun/VerifyOverlimit`, params)
}

// sold管理

export const Account_info_GetSoldToList = (params) => {
  return axios.get(`${base}/api/Account_info/GetSoldToList`, {
    params: params,
  })
}

export const Account_info_UpSoldTo = (params) => {
  return axios.post(`${base}/api/Account_info/UpSoldTo`, params)
}

// 人员端口管理

export const organization_GetOrgList = (params) => {
  return axios.get(`${base}/api/organization/GetOrgList`, {
    params: params,
  })
}

export const organization_GetOrgById = (params) => {
  return axios.get(`${base}/api/organization/GetOrgById`, {
    params: params,
  })
}

export const Account_info_ExportStore = (params) => {
  return axios.get(`${base}/api/Account_info/ExportStore`, {
    params: params,
  })
}

export const organization_UpdateOrgSalesCity = (params) => {
  return axios.post(`${base}/api/organization/UpdateOrgSalesCity`, params)
}

// export const organization_GetMyOrg = (params) => {
//   return axios.post(`${base}/api/organization/GetMyOrg`, params);
// };

export const organization_GetMyOrg = (params) => {
  return axios.get(`${base}/api/organization/GetMyOrg`, {
    params: params,
  })
}

export const store_data_GetOrganization_role = (params) => {
  return axios.get(`${base}/api/store_data/GetOrganization_role`, {
    params: params,
  })
}

export const cp_budget_GetBudgetByQ = (params) => {
  return axios.get(`${base}/api/cp_budget/GetBudgetByQ`, {
    params: params,
  })
}

export const cp_budget_GetBudgetList = (params) => {
  return axios.get(`${base}/api/cp_budget/GetBudgetList`, {
    params: params,
  })
}

export const cp_giveaway_GetProduct_List = (params) => {
  return axios.post(`${base}/api/cp_giveaway/GetProduct_List`, params)
}

// export const cp_giveaway_GetProductByType_List = (params) => {
//   return axios.post(`${base}/api/cp_giveaway/GetProductByType_List`, params);
// };

export const cp_giveaway_GetProductByType_List = (params) => {
  return axios.get(`${base}/api/cp_giveaway/GetProductByType_List`, {
    params: params,
  })
}

export const cp_giveaway_GetProductType_List = (params) => {
  return axios.post(`${base}/api/cp_giveaway/GetProductType_List`, params)
}

export const cp_giveaway_GiveawayImportData = (params) => {
  return axios.post(`${base}/api/cp_giveaway/GiveawayImportData`, params)
}

export const cp_giveaway_Post = (params) => {
  return axios.post(`${base}/api/cp_giveaway/Post`, params)
}

export const cp_giveaway_Del = (params) => {
  return axios.delete(`${base}/api/cp_giveaway/Del`, { params: params })
}

export const cp_apply_Add = (params) => {
  return axios.post(`${base}/api/cp_apply/Add`, params)
}

// export const cp_apply_UptReceiptd = (params) => {
//   return axios.post(`${base}/api/cp_apply/UptReceipt`, params);
// };
export const cp_apply_UptReceiptd = (params) => {
  return axios.put(`${base}/api/cp_apply/UptReceipt`, params)
}

export const cp_apply_AddDraft = (params) => {
  return axios.post(`${base}/api/cp_apply/AddDraft`, params)
}

export const cp_apply_ReceiptAppr = (params) => {
  return axios.post(`${base}/api/cp_apply/ReceiptAppr`, params)
}

export const cp_apply_GetAppr = (params) => {
  return axios.get(`${base}/api/cp_apply/GetAppr`, {
    params: params,
  })
}

export const cp_apply_GetApprInfo = (params) => {
  return axios.get(`${base}/api/cp_apply/GetApprInfo`, {
    params: params,
  })
}

// export const cp_apply_GetAppr = (params) => {
//   return axios.get(`${base}/api/cp_apply/GetAppr`, {
//     params: params,
//   });
// };

export const cp_apply_GetApprList = (params) => {
  return axios.get(`${base}/api/cp_apply/GetApprList`, {
    params: params,
  })
}

export const cp_apply_GetNotAppr = (params) => {
  return axios.get(`${base}/api/cp_apply/GetNotAppr`, {
    params: params,
  })
}

export const cp_apply_UptReceipt = (params) => {
  return axios.put(`${base}/api/cp_apply/UptReceipt`, params)
}

// 预算分配

// export const cp_budget_GetBudgetByQ = (params) => {
//   return axios.get(`${base}/api/cp_budget/GetBudgetByQ`, {
//     params: params,
//   });
// };

export const cp_budget_progress_GetBudgetList = (params) => {
  return axios.get(`${base}/api/cp_budget_progress/Get`, {
    params: params,
  })
}

export const cp_budget_progress_Post = (params) => {
  return axios.post(`${base}/api/cp_budget_progress/Post`, params)
}

export const cp_budget_progress_Put = (params) => {
  return axios.put(`${base}/api/cp_budget_progress/Put`, params)
}

export const cp_apply_Put = (params) => {
  return axios.put(`${base}/api/cp_apply/Put`, params)
}

export const cp_apply_PostPo = (params) => {
  return axios.post(`${base}/api/cp_apply/PostPo`, params)
}

export const cp_apply_ExportExcel = (params) => {
  return axios.get(`${base}/api/cp_apply/ExportExcel`, {
    params: params,
  })
}

// 赠品发货及库存管理

export const cp_po_DownloadByPoId = (params) => {
  return axios.get(`${base}/api/cp_po/DownloadByPoId`, {
    params: params,
  })
}

export const cp_po_GetDeliveryList = (params) => {
  return axios.get(`${base}/api/cp_po/GetDeliveryList`, {
    params: params,
  })
}

export const cp_po_GetInventoryDetail = (params) => {
  return axios.get(`${base}/api/cp_po/GetInventoryDetail`, {
    params: params,
  })
}

export const cp_po_GetList = (params) => {
  return axios.get(`${base}/api/cp_po/GetInventoryList`, {
    params: params,
  })
}

export const cp_po_Po_DeliveryImportData = (params) => {
  return axios.post(`${base}/api/cp_po/Po_DeliveryImportData`, params)
}

export const cp_po_Po_InventoryImportData = (params) => {
  return axios.post(`${base}/api/cp_po/Po_InventoryImportData`, params)
}

export const Account_info_GetGroupIDList = (params) => {
  return axios.get(`${base}/api/Account_info/GetGroupIDList`, {
    params: params,
  })
}

export const Account_info_GetPayerNameList = (params) => {
  return axios.get(`${base}/api/Account_info/GetPayerNameList`, {
    params: params,
  })
}

export const product_GetEtrialobSelect = (params) => {
  return axios.get(`${base}/api/product/GetEtrialobSelect`, {
    params: params,
  })
}

export const Account_info_GetAccountGroupIDList = (params) => {
  return axios.get(`${base}/api/Account_info/GetAccountGroupIDList`, {
    params: params,
  })
}

// 补片系统

export const replenish_GetProductList = (params) => {
  return axios.get(`${base}/api/replenish/GetProductList`, {
    params: params,
  })
}

export const replenish_GetProductInfoList = (params) => {
  return axios.get(`${base}/api/replenish/GetProductInfoList`, {
    params: params,
  })
}

export const replenish_AddReplenish = (params) => {
  return axios.post(`${base}/api/replenish/AddReplenish`, params)
}
// 已审批
export const replenish_GetApprovedList = (params) => {
  return axios.get(`${base}/api/replenish/GetApprovedList`, {
    params: params,
  })
}

// 待审批
export const replenish_GetNotApprovedList = (params) => {
  return axios.get(`${base}/api/replenish/GetNotApprovedList`, {
    params: params,
  })
}

// 申请列表
export const replenish_GetProcessReview = (params) => {
  return axios.get(`${base}/api/replenish/GetProcessReview`, {
    params: params,
  })
}

export const replenish_Getbyid = (params) => {
  return axios.get(`${base}/api/replenish/Getbyid`, {
    params: params,
  })
}

export const store_data_GetEtrialynStoreInfoList = (params) => {
  return axios.get(`${base}/api/store_data/GetEtrialynStoreInfoList`, {
    params: params,
  })
}

export const replenish_ExportReplenish = (params) => {
  return axios.get(`${base}/api/replenish/ExportReplenish`, {
    params: params,
  })
}

export const product_quotas_ExportProductQuotas = (params) => {
  return axios.get(`${base}/api/product_quotas/ExportProductQuotas`, {
    params: params,
  })
}

export const product_quotas_GetProductQuotasList = (params) => {
  return axios.get(`${base}/api/product_quotas/GetProductQuotasList`, {
    params: params,
  })
}

export const cp_freeze_GetInfoList = (params) => {
  return axios.get(`${base}/api/cp_freeze/GetInfoList`, {
    params: params,
  })
}

export const cp_freeze_GetIsFreeze = (params) => {
  return axios.get(`${base}/api/cp_freeze/GetIsFreeze`, {
    params: params,
  })
}

export const cp_freeze_UpdateFreeze = (params) => {
  return axios.post(`${base}/api/cp_freeze/UpdateFreeze`, params)
}
// /api/product_quotas/GetProductQuotasList
export const jdcard_GetList = (params) => {
  return axios.get(`${base}/api/jdcard/GetList`, {
    params: params,
  })
}

export const jdcard_InvoiceSubmit = (params) => {
  return axios.post(`${base}/api/jdcard/InvoiceSubmit`, params)
}

// 消息管理
export const MessageInfo_Delete = (params) => {
  return axios.delete(`${base}/api/MessageInfo/Delete`, { params: params })
}
export const MessageInfo_Update = (params) => {
  return axios.post(`${base}/api/MessageInfo/Update`, params)
}

export const MessageInfo_Add = (params) => {
  return axios.post(`${base}/api/MessageInfo/Add`, params)
}

// export const MessageInfo_Get = (params) => {
//   return axios.get(`${base}/api/MessageInfo/Get`, {
//     params: params,
//   });
// };

export const MessageInfo_GetList = (params) => {
  return axios.get(`${base}/api/MessageInfo/GetList`, {
    params: params,
  })
}

export const cp_apply_PostPr = (params) => {
  return axios.post(`${base}/api/cp_apply/PostPr`, params)
}

export const cp_apply_ApplyContinue = (params) => {
  return axios.post(`${base}/api/cp_apply/ApplyContinue`, params)
}

export const cp_apply_ConsentContinue = (params) => {
  return axios.post(`${base}/api/cp_apply/ConsentContinue`, params)
}

// export const cp_apply_CheckInfoListGet= (params) => {
//   return axios.post(`${base}/api/cp_apply/CheckInfoListGet`, params);
// };

export const cp_apply_CheckInfoListGet = (params) => {
  return axios.get(`${base}/api/cp_apply/CheckInfoListGet`, {
    params: params,
  })
}

// 获取发票列表
export const myacuvue_order_Get_billing = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_billing`, params)
}

//  获取订单列表
export const myacuvue_order_Get_Order = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_Order`, params)
}

//  获取UDI列表
export const myacuvue_order_Get_UDI = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_UDI`, params)
}

// 导出发票数据
export const myacuvue_order_DownloadBilling = (params) => {
  return axios.get(`${base}/api/myacuvue_order/DownloadBilling`, {
    params: params,
  })
}

// 导出订单
// export const myacuvue_order_DownloadOrder = (params) => {
//   return axios.post(`${base}/api/myacuvue_order/DownloadOrder`, {
//     params: params,
//   });
// };

export const myacuvue_order_DownloadOrder = (params) => {
  return axios.post(`${base}/api/myacuvue_order/DownloadOrder`, params)
}

// 导出UDI
// export const myacuvue_order_DownloadUDI = (params) => {
//   return axios.get(`${base}/api/myacuvue_order/DownloadUDI`, {
//     params: params,
//   });
// };
export const myacuvue_order_DownloadUDI = (params) => {
  return axios.post(`${base}/api/myacuvue_order/DownloadUDI`, params)
}

// 配额数量
export const Qouta_GetInfo = (params) => {
  return axios.get(`${base}/api/Qouta/GetInfo`, {
    params: params,
  })
}
export const QoutaZEX_GetInfo = (params) => {
  return axios.get(`${base}/api/QoutaZEX/GetInfo`, {
    params: params,
  })
}
export const QoutaCRM_GetInfo = (params) => {
  return axios.get(`${base}/api/QoutaCRM/GetInfo`, {
    params: params,
  })
}

export const Qouta_GetList = (params) => {
  return axios.get(`${base}/api/Qouta/GetList`, {
    params: params,
  })
}
export const QoutaZEX_GetList = (params) => {
  return axios.get(`${base}/api/QoutaZEX/GetList`, {
    params: params,
  })
}
export const QoutaCRM_GetList = (params) => {
  return axios.get(`${base}/api/QoutaCRM/GetList`, {
    params: params,
  })
}

export const Qouta_ExportQoutaExcel = (params) => {
  return axios.get(`${base}/api/Qouta/ExportQoutaExcel`, {
    params: params,
  })
}

export const QoutaZEX_ExportQoutaExcel = (params) => {
  return axios.get(`${base}/api/QoutaZEX/ExportQoutaExcel`, {
    params: params,
  })
}

export const QoutaCRM_ExportQoutaExcel = (params) => {
  return axios.get(`${base}/api/QoutaCRM/ExportQoutaExcel`, {
    params: params,
  })
}

export const Qouta_ExportQoutaInfoAddQoutaExcel = (params) => {
  return axios.get(`${base}/api/Qouta/ExportQoutaInfoAddQoutaExcel`, {
    params: params,
  })
}

export const QoutaCRM_ExportQoutaInfoAddQoutaExcel = (params) => {
  return axios.get(`${base}/api/QoutaCRM/ExportQoutaInfoAddQoutaExcel`, {
    params: params,
  })
}

export const QoutaZEX_ExportQoutaInfoAddQoutaExcel = (params) => {
  return axios.get(`${base}/api/QoutaZEX/ExportQoutaInfoAddQoutaExcel`, {
    params: params,
  })
}

// 配额详情
// 配额调换
export const QoutaInfo_Add = (params) => {
  return axios.post(`${base}/api/QoutaInfo/Add`, params)
}

// 己审批
export const QoutaInfo_GetApprove = (params) => {
  return axios.get(`${base}/api/QoutaInfo/GetApprove`, {
    params: params,
  })
}

// 待审批
export const QoutaInfo_GetNotApprove = (params) => {
  return axios.get(`${base}/api/QoutaInfo/GetNotApprove`, {
    params: params,
  })
}

//  冻结配额
export const QoutaInfo_FreezeQouta = (params) => {
  return axios.post(`${base}/api/QoutaInfo/FreezeQouta`, params)
}

// 审批接口
export const QoutaInfo_Put = (params) => {
  return axios.put(`${base}/api/QoutaInfo/Put`, params)
}

export const Qouta_GetAccountQouta = (params) => {
  return axios.get(`${base}/api/Qouta/GetAccountQouta`, {
    params: params,
  })
}

// 导出
export const SellInModel_ExportSellinExcel = (params) => {
  return axios.get(`${base}/api/SellInModel/ExportSellinExcel`, {
    params: params,
  })
}

//  导入
export const SellInModel_ImportSellinExcel = (params) => {
  return axios.post(`${base}/api/SellInModel/ImportSellinExcel`, params)
}

export const QoutaInfo_GetApproveList = (params) => {
  return axios.get(`${base}/api/QoutaInfo/GetApproveList`, {
    params: params,
  })
}
export const QoutaInfoZEX_GetApproveList = (params) => {
  return axios.get(`${base}/api/QoutaInfoZEX/GetApproveList`, {
    params: params,
  })
}
export const QoutaInfoCRM_GetApproveList = (params) => {
  return axios.get(`${base}/api/QoutaInfoCRM/GetApproveList`, {
    params: params,
  })
}

export const Qouta_GetQoutaList = (params) => {
  return axios.get(`${base}/api/Qouta/GetQoutaList`, {
    params: params,
  })
}
export const QoutaZEX_GetQoutaList = (params) => {
  return axios.get(`${base}/api/QoutaZEX/GetQoutaList`, {
    params: params,
  })
}
export const QoutaCRM_GetQoutaList = (params) => {
  return axios.get(`${base}/api/QoutaCRM/GetQoutaList`, {
    params: params,
  })
}

export const QoutaInfo_GetQoutaInfoApprovalInfo = (params) => {
  return axios.get(`${base}/api/QoutaInfo/GetQoutaInfoApprovalInfo`, {
    params: params,
  })
}

export const QoutaInfoCRM_GetQoutaInfoApprovalInfo = (params) => {
  return axios.get(`${base}/api/QoutaInfoCRM/GetQoutaInfoApprovalInfo`, {
    params: params,
  })
}

export const QoutaInfoZEX_GetQoutaInfoApprovalInfo = (params) => {
  return axios.get(`${base}/api/QoutaInfoZEX/GetQoutaInfoApprovalInfo`, {
    params: params,
  })
}

export const Myacuvue_prj_user_infoModel_GetApplyList = (params) => {
  return axios.get(`${base}/api/Myacuvue_prj_user_infoModel/GetApplyList`, {
    params: params,
  })
}

export const Myacuvue_prj_user_infoModel_UpdateState = (params) => {
  return axios.post(`${base}/api/Myacuvue_prj_user_infoModel/UpdateState`, params)
}

export const Login_GetMobileJwtTokenPwdMail = (params) => {
  return axios.get(`${base}/api/Login/GetMobileJwtTokenPwdMail`, {
    params: params,
  })
}

export const QoutaInfo_GetAddApprove = (params) => {
  return axios.get(`${base}/api/QoutaInfo/GetAddApprove`, {
    params: params,
  })
}

export const QoutaInfo_GetAddApproveList = (params) => {
  return axios.get(`${base}/api/QoutaInfo/GetAddApproveList`, {
    params: params,
  })
}

export const QoutaInfo_GetAddNotApprove = (params) => {
  return axios.get(`${base}/api/QoutaInfo/GetAddNotApprove`, {
    params: params,
  })
}

export const myacuvue_order_Get_OrderTotal = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_OrderTotal`, params)
}

export const myacuvue_order_Get_Order2 = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_Order2`, params)
}
export const myacuvue_order_Get_OrderDetail = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_OrderDetail`, params)
}

// export const myacuvue_order_DownloadOrderDetail = (params) => {
//   return axios.post(`${base}/api/myacuvue_order/DownloadOrderDetail`, {
//     params: params,
//   });
// };
export const myacuvue_order_DownloadOrderDetail = (params) => {
  return axios.post(`${base}/api/myacuvue_order/DownloadOrderDetail`, params)
}

export const jdcard_InvoiceSubmitSumPredict = (params) => {
  return axios.post(`${base}/api/jdcard/InvoiceSubmitSumPredict`, params)
}

export const jdcard_GetInvoiceSelect = (params) => {
  return axios.post(`${base}/api/jdcard/GetInvoiceSelect`, params)
}

export const QoutaInfo_AddAdvanceQouta = (params) => {
  return axios.post(`${base}/api/QoutaInfo/AddAdvanceQouta`, params)
}
export const QoutaInfoZEX_AddAdvanceQouta = (params) => {
  return axios.post(`${base}/api/QoutaInfoZEX/AddAdvanceQouta`, params)
}
export const QoutaInfoCRM_AddAdvanceQouta = (params) => {
  return axios.post(`${base}/api/QoutaInfoCRM/AddAdvanceQouta`, params)
}

export const QoutaInfo_AddNoApp = (params) => {
  return axios.post(`${base}/api/QoutaInfo/AddNoApp`, params)
}

export const QoutaInfoZEX_AddNoApp = (params) => {
  return axios.post(`${base}/api/QoutaInfoZEX/AddNoApp`, params)
}

export const QoutaInfoCRM_AddNoApp = (params) => {
  return axios.post(`${base}/api/QoutaInfoCRM/AddNoApp`, params)
}

export const myacuvue_order_Get_user_account = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_user_account`, params)
}

export const myacuvue_order_Get_Delivery_no = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_Delivery_no`, params)
}

export const myacuvue_order_Get_Delivery_no_2 = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_Delivery_no_2`, params)
}

export const QoutaInfo_AddAddQouta = (params) => {
  return axios.post(`${base}/api/QoutaInfo/AddAddQouta`, params)
}
export const QoutaInfoCRM_AddAddQouta = (params) => {
  return axios.post(`${base}/api/QoutaInfoCRM/AddAddQouta`, params)
}
export const QoutaInfoZEX_AddAddQouta = (params) => {
  return axios.post(`${base}/api/QoutaInfoZEX/AddAddQouta`, params)
}

export const SellInModel_ImportSellinExcel2 = (params) => {
  return axios.post(`${base}/api/SellInModel/ImportSellinExcel2`, params)
}

export const myacuvue_order_GetSuperXProduct = (params) => {
  return axios.post(`${base}/api/myacuvue_order/GetSuperXProduct`, params)
}

export const organization_GetTokenStste = (params) => {
  return axios.get(`${base}/api/Login/GetTokenStste`, {
    params: params,
  })
}

export const Account_info_GetSalesRegion = (params) => {
  return axios.get(`${base}/api/Account_info/GetSalesRegion`, {
    params: params,
  })
}
export const Account_info_GetSalesRegion2 = (params) => {
  return axios.get(`${base}/api/Account_info/GetSalesRegion2`, {
    params: params,
  })
}
export const Qouta_GetLoanQoutaExcel = (params) => {
  return axios.get(`${base}/api/Qouta/GetLoanQoutaExcel`, {
    params: params,
  })
}

export const QoutaZEX_GetLoanQoutaExcel = (params) => {
  return axios.get(`${base}/api/QoutaZEX/GetLoanQoutaExcel`, {
    params: params,
  })
}

export const QoutaCRM_GetLoanQoutaExcel = (params) => {
  return axios.get(`${base}/api/QoutaCRM/GetLoanQoutaExcel`, {
    params: params,
  })
}

export const cp_budget_customer_DeleteObj = (params) => {
  return axios.delete(`${base}/api/cp_budget_customer/DeleteObj`, { params: params })
}

export const cp_budget_customer_UpdateObj = (params) => {
  return axios.post(`${base}/api/cp_budget_customer/UpdateObj`, params)
}

export const cp_budget_customer_GetExprotcp_budget_customer = (params) => {
  return axios.get(`${base}/api/cp_budget_customer/GetExprotcp_budget_customer`, {
    params: params,
  })
}

export const cp_budget_customer_ImprotExcelCustomer = (params) => {
  return axios.post(`${base}/api/cp_budget_customer/ImprotExcelCustomer`, params)
}

export const cp_budget_customer_ImprotExcel1 = (params) => {
  return axios.post(`${base}/api/cp_budget_customer/ImprotExcel1`, params)
}

export const cp_budget_customer_ImprotExcel2 = (params) => {
  return axios.post(`${base}/api/cp_budget_customer/ImprotExcel2`, params)
}

export const product_quotas_UpdateProductQuotas = (params) => {
  return axios.post(`${base}/api/product_quotas/UpdateProductQuotas`, params)
}

export const myacuvue_order_Get_user_accountinfo = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_user_accountinfo`, params)
}

export const myacuvue_order_Get_DeliveryInfo = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_DeliveryInfo`, params)
}

export const myacuvue_order_DownloadDeliveryInfo = (params) => {
  return axios.post(`${base}/api/myacuvue_order/DownloadDeliveryInfo`, params)
}

export const myacuvue_order_DownloadReturn_VAT = (params) => {
  return axios.post(`${base}/api/myacuvue_order/DownloadReturn_VAT`, params)
}

export const Myacuvue_prj_user_infoModel_Get_User_Info = (params) => {
  return axios.post(`${base}/api/Myacuvue_prj_user_infoModel/Get_User_Info`, params)
}

export const Myacuvue_prj_user_infoModel_Get_Account = (params) => {
  return axios.post(`${base}/api/Myacuvue_prj_user_infoModel/Get_Account`, params)
}

export const Myacuvue_prj_user_infoModel_Add_User_Permission = (params) => {
  return axios.post(`${base}/api/Myacuvue_prj_user_infoModel/Add_User_Permission`, params)
}

export const myacuvue_orderIs_Account = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Is_Account`, params)
}

export const Add_ALL_User_Permission = (params) => {
  return axios.post(`${base}/api/Myacuvue_prj_user_infoModel/Add_ALL_User_Permission`, params)
}

export const store_data_GetShippingAdsTypeList = (params) => {
  return axios.get(`${base}/api/store_data/GetShippingAdsTypeList`, {
    params: params,
  })
}

export const trial_info_update_hegui = (params) => {
  return axios.post(`${base}/api/trial_info/update_hegui`, params)
}

export const trial_info_Get_Etrial_Campain = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Etrial_Campain`, {
    params: params,
  })
}

export const trial_info_Get_Etrial_Campain_info = (params) => {
  return axios.get(`${base}/api/trial_info/Get_Etrial_Campain_info`, {
    params: params,
  })
}

export const report_template_DownloadETrial_PoXiao = (params) => {
  return axios.get(`${base}/api/report_template/DownloadETrial_PoXiao`, {
    params: params,
  })
}

export const report_template_DownloadETrial_PoXiao_Campain = (params) => {
  return axios.get(`${base}/api/report_template/DownloadETrial_PoXiao_Campain`, {
    params: params,
  })
}

export const trial_info_upload_receipt_file = (params) => {
  return axios.get(`${base}/api/trial_info/upload_receipt_file`, {
    params: params,
  })
}

export const trial_info_update_shenpi = (params) => {
  return axios.post(`${base}/api/trial_info/update_shenpi`, params)
}

export const myacuvue_order_Get_Return_VAT = (params) => {
  return axios.post(`${base}/api/myacuvue_order/Get_Return_VAT`, params)
}

export const report_template_DownloadETrial_PoXiao_Campain_Apply = (params) => {
  return axios.get(`${base}/api/report_template/DownloadETrial_PoXiao_Campain_Apply`, {
    params: params,
  })
}

export const approval_request_Get_Confirm = (params) => {
  return axios.get(`${base}/api/approval_request/Get_Confirm`, {
    params: params,
  })
}

export const mail_template_Put_Confirm_Email = (params) => {
  return axios.post(`${base}/api/mail_template/Put_Confirm_Email`, params)
}

export const approval_request_LM_Confirm_OK = (params) => {
  return axios.post(`${base}/api/approval_request/LM_Confirm_OK`, params)
}

export const approval_request_Confirm = (params) => {
  return axios.post(`${base}/api/approval_request/Confirm`, params)
}

export const organization_Find_claim_confirm_info = (params) => {
  return axios.post(`${base}/api/organization/Find_claim_confirm_info`, params)
}

export const Structures_Find_update = (params) => {
  return axios.post(`${base}/api/Structures/update`, params)
}

export const Account_info_ExportDISList = (params) => {
  return axios.get(`${base}/api/Account_info/ExportDISList`, {
    params: params,
  })
}

export const Structures_Getstructures = (params) => {
  return axios.get(`${base}/api/Structures/Getstructures`, {
    params: params,
  })
}

export const Structures_Getdepartment = (params) => {
  return axios.get(`${base}/api/Structures/Getdepartment`, {
    params: params,
  })
}

export const Structures_Getorganization = (params) => {
  return axios.get(`${base}/api/Structures/Getorganization`, {
    params: params,
  })
}

export const Structures_Getdepartment_Info = (params) => {
  return axios.get(`${base}/api/Structures/Getdepartment_Info`, {
    params: params,
  })
}

export const Structures_update_department = (params) => {
  return axios.post(`${base}/api/Structures/update_department`, params)
}

export const Structures_insert_department = (params) => {
  return axios.post(`${base}/api/Structures/insert_department`, params)
}

// layer2试点用户
export const Account_info_Pilot_User = (params) => {
  return axios.get(`${base}/api/Account_info/Pilot_User`, {
    params: params,
  })
}

export const AliyunQWen_OcrBusinessLicense = (params) => {
  return axios.post(`${base}/api/AliyunQWen/OcrBusinessLicense`, params)
}
